import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'boat',
      d: 'M-4,-1.5h0.5v1h-0.5zM3,-1h1v0.5h-1zM-3.5,-0.5h2v0.5h-2zM0,-0.5h3.5v0.5h-3.5zM-3,0h6v0.5h-6z',
    },
    {
      paint: 'dock',
      d: 'M-1.5,-2h1v0.5h-1zM0.5,-2h1v0.5h-1zM-3.5,-1.5h1.5v0.5h-1.5zM-1,-1.5h0.5v0.5h-0.5zM1.5,-1.5h2.5v0.5h-2.5zM-3.5,-1h2.5v0.5h-2.5zM-0.5,-1h3.5v0.5h-3.5zM-1.5,-0.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'trunk',
      d: 'M-0.5,-7h0.5v5h-0.5zM-0.5,-2h1v0.5h-1zM1.5,-2h1v0.5h-1zM-2,-1.5h1v0.5h-1zM-0.5,-1.5h2v0.5h-2zM-1,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'sail',
      d: 'M0,-7h0.5v0.5h-0.5zM-1,-6.5h0.5v0.5h-0.5zM0,-6.5h1v0.5h-1zM-1.5,-6h1v1h-1zM0,-6h1.5v0.5h-1.5zM0,-5.5h2v1h-2zM-2,-5h1.5v1h-1.5zM0,-4.5h2.5v1.5h-2.5zM-2.5,-4h2v2h-2zM0,-3h3v0.5h-3zM0,-2.5h2.5v0.5h-2.5z',
    },
    { paint: 'whaleBelly', d: 'M2.5,-2.5h0.5v0.5h-0.5z' },
    { paint: 'flag', d: 'M-0.5,-7.5h1.5v0.5h-1.5z' },
  ],
  pixels: 147,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'boat',
      d: 'M-3.5,-1.5h0.5v0.5h-0.5zM3,-1.5h0.5v0.5h-0.5zM-3,-1h0.5v0.5h-0.5zM2.5,-1h1v0.5h-1zM-3,-0.5h2v0.5h-2zM0,-0.5h3v0.5h-3zM-2.5,0h5v0.5h-5z',
    },
    {
      paint: 'dock',
      d: 'M-1.5,-2h0.5v0.5h-0.5zM-0.5,-2h2v0.5h-2zM-3,-1.5h1.5v0.5h-1.5zM-0.5,-1.5h0.5v0.5h-0.5zM1,-1.5h2v0.5h-2zM-2.5,-1h1.5v0.5h-1.5zM-0.5,-1h3v0.5h-3zM-1,-0.5h1v0.5h-1z',
    },
    {
      paint: 'trunk',
      d: 'M0.5,-7h1v0.5h-1zM-1,-6.5h0.5v0.5h-0.5zM-1,-2.5h1.5v0.5h-1.5zM-1,-2h0.5v0.5h-0.5zM-1.5,-1.5h1v0.5h-1zM0,-1.5h1v0.5h-1zM-1,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'wheat',
      d: 'M1.5,-7h0.5v0.5h-0.5zM-2,-6.5h1v0.5h-1zM-0.5,-6.5h0.5v0.5h-0.5zM1.5,-3h1v0.5h-1zM-1.5,-2.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'sail',
      d: 'M0,-6.5h1v0.5h-1zM1.5,-6.5h0.5v0.5h-0.5zM-2,-6h4v0.5h-4zM-2,-5.5h4.5v2.5h-4.5zM-1.5,-3h3v0.5h-3z',
    },
    { paint: 'whaleBelly', d: 'M1,-6.5h0.5v0.5h-0.5z' },
    { paint: 'flag', d: 'M-1,-7h1.5v0.5h-1.5z' },
  ],
  pixels: 134,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'boat',
      d: 'M-4,-1h0.5v0.5h-0.5zM3.5,-1h0.5v0.5h-0.5zM-3.5,-0.5h2v0.5h-2zM1,-0.5h2.5v0.5h-2.5zM-2.5,0h5.5v0.5h-5.5z',
    },
    {
      paint: 'dock',
      d: 'M-3.5,-1.5h7.5v0.5h-7.5zM-3.5,-1h1.5v0.5h-1.5zM-0.5,-1h0.5v0.5h-0.5zM1,-1h2.5v0.5h-2.5zM-1.5,-0.5h2.5v0.5h-2.5z',
    },
    {
      paint: 'trunk',
      d: 'M0,-6h0.5v1h-0.5zM1,-6h0.5v0.5h-0.5zM-1.5,-4h0.5v0.5h-0.5zM-3,-2.5h0.5v0.5h-0.5zM-1.5,-2h2.5v0.5h-2.5zM-2,-1h1.5v0.5h-1.5zM0,-1h1v0.5h-1z',
    },
    {
      paint: 'wheat',
      d: 'M2.5,-7h0.5v0.5h-0.5zM0.5,-5.5h0.5v0.5h-0.5zM0,-5h0.5v0.5h-0.5zM-2,-3.5h0.5v0.5h-0.5zM-2.5,-3h0.5v0.5h-0.5zM1,-2h0.5v0.5h-0.5z',
    },
    {
      paint: 'sail',
      d: 'M2,-6.5h1v0.5h-1zM1.5,-6h1.5v0.5h-1.5zM1,-5.5h2v0.5h-2zM0.5,-5h2v0.5h-2zM-0.5,-4.5h3v0.5h-3zM-1,-4h3.5v0.5h-3.5zM-1.5,-3.5h3.5v0.5h-3.5zM-2,-3h4v0.5h-4zM-2.5,-2.5h4.5v0.5h-4.5z',
    },
  ],
  pixels: 122,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
